import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { OngoingActivitiesByCourseUseCaseInterface } from 'domain/usecases';

export class RemoteOngoingActivitiesByCourse
  implements OngoingActivitiesByCourseUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<
      OngoingActivitiesByCourseUseCaseInterface.Result[]
    >,
  ) {}

  async execute(
    params: OngoingActivitiesByCourseUseCaseInterface.Params,
  ): Promise<OngoingActivitiesByCourseUseCaseInterface.Result[]> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: this.url + params.id + '/overview/courses-activities-count',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
